import { AppointmentBookingError } from "~/features/appointments/pages/error";

export function AppointmentErrorPage() {
  return <AppointmentBookingError />
}
